import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var JobService = /** @class */ (function () {
    function JobService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.serviceUrl = this.env.servicePath;
    }
    JobService.prototype.createJobList = function (jobType) {
        var path = this.serviceUrl + "CreateJobListCard/" + jobType;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    JobService.prototype.getJobList = function (id) {
        var path = this.serviceUrl + "GetJobListCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    JobService.prototype.triggerJob = function (id, jobId) {
        var path = this.serviceUrl + "TriggerJob/" + id + "/" + jobId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    JobService.ngInjectableDef = i0.defineInjectable({ factory: function JobService_Factory() { return new JobService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: JobService, providedIn: "root" });
    return JobService;
}());
export { JobService };
